import { Component, OnInit, ChangeDetectionStrategy, OnChanges, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AssignCoverImageCommand, GetProductBySkuQuery, ProductClient, SkuResult, UpdateDescriptionCommand, UploadProductImagesCommand, WishlistModel } from '@core/services/api.service';
import { AppendProductNameAction } from '@ngxs-store/breadcrumb-store/breadcrumb.actions';
import { AddItemToCartAction } from '@ngxs-store/cart/cart.actions';
import { AssignCoverImageAction, GetProductBySkuAction, UpdateDescriptionAction, UploadProductImagesAction } from '@ngxs-store/product-store/product.actions';
import { ProductState } from '@ngxs-store/product-store/product.state';
import { AddItemToWishListAction } from '@ngxs-store/wish-list-store/wish-list.actions';
import { WishListState } from '@ngxs-store/wish-list-store/wish-list.state';
import { Select, Store } from '@ngxs/store';
import { Observable, Subject } from 'rxjs';
import { AuthState } from '@ngxs-store/auth-store/auth.state';
import { DecodedToken } from '@core/models';

@Component({
    selector: 'app-product-detail-page',
    template: `
        <app-product-detail
            [isLoading]="isLoading$ | async"
            [product]="ProductReturnModel$ | async"
            [wishlist]="wishlist$ | async"
            (productLoaded)="setProductName($event)"
            (addToCart)="addToCart($event)"
            (addToWishlist)="addToWishlist($event)"
            (uploadFiles)="uploadFiles($event)"
            (assignCover)="assignCover($event)"
            (updatedDescription)="updatedDescription($event)"
            [decodedToken]="decodedToken$ | async">
        </app-product-detail>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductDetailPageComponent implements OnInit, OnDestroy {

    productCode: any;
    product$: Observable<SkuResult>;
    private readonly onDestroy = new Subject<void>();
    @Select(ProductState.getProductBySkuCode) ProductReturnModel$: Observable<SkuResult>;
    @Select(WishListState.getItems) wishlist$: Observable<WishlistModel>;
    @Select(ProductState.isLoading) isLoading$: Observable<boolean>;
    @Select(AuthState.getDecodedToken) decodedToken$: Observable<DecodedToken>;

    constructor(
        private store: Store,
        private activatedRoute: ActivatedRoute,

    ) { }

    ngOnInit() {
        this.activatedRoute.params.subscribe((params) => {
            const getProductSkuQuery = new GetProductBySkuQuery();
            getProductSkuQuery.skuCode = params.productCode;
            this.store.dispatch(new GetProductBySkuAction({ loadProductsBySkuQuery: getProductSkuQuery }));
        });
    }

    ngOnDestroy() {
        this.onDestroy.next();
    }

    setProductName($event) {
        this.store.dispatch(new AppendProductNameAction({ productName: $event.skuDescription, id: $event.skuCode }))
    }

    addToCart($event) {
        this.store.dispatch(new AddItemToCartAction({ command: $event }));
    }

    addToWishlist($event) {
        this.store.dispatch(new AddItemToWishListAction({ command: $event }));
    }

    uploadFiles($event) {
        let srcs: string[] = [];
        let skuCode: string = "";

        $event.forEach(image => {
            srcs.push(image.src);
            skuCode = image.skuCode;
        });

        let uploadProductImagesCommand = new UploadProductImagesCommand({
            src: srcs,
            skuCode: skuCode
        });

        this.store.dispatch(new UploadProductImagesAction({ command: uploadProductImagesCommand }));
    }

    assignCover($event) {
        let assignCoverImageCommand = new AssignCoverImageCommand({
            mainImageIndex: $event.mainImageIndex,
            skuCode: $event.skuCode,
            src: $event.src
        });

        this.store.dispatch(new AssignCoverImageAction({ command: assignCoverImageCommand}));
    }

    updatedDescription($event) {
        let updateDescriptionCommand = new UpdateDescriptionCommand({
            updatedDescription: $event.updatedDescription,
            skuCode: $event.skuCode
        });

        this.store.dispatch(new UpdateDescriptionAction({ command: updateDescriptionCommand }));
    }
}
